(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24638],{

/***/ 50085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FAQ; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/debtreliefanalysis/icons/faqImage.tsx


function FaqImage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 365 524",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M230.99 524C157.022 524 97.0586 518.923 97.0586 512.659C97.0586 506.396 157.022 501.318 230.99 501.318C304.958 501.318 364.921 506.396 364.921 512.659C364.921 518.923 304.958 524 230.99 524Z",
                fill: "url(#paint0_linear_13_352)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.8773 462.883C56.5633 461.183 38.2667 411.601 47.4567 407.456C54.6149 404.235 58.168 411.801 59.2516 414.655C60.95 419.146 64.3363 430.217 67.4309 428.422C73.047 425.18 60.9395 398.285 58.3867 391.548C55.834 384.811 52.7081 371.033 57.4282 364.621C62.1482 358.21 64.7843 356.164 68.5874 368.2C72.3905 380.236 76.923 404.927 81.7056 396.984C86.4881 389.04 78.486 370.75 77.7462 358.609C77.0064 346.468 79.705 323.004 87.478 327.726C94.4278 331.924 91.5103 367.864 97.3557 365.618C102.024 363.824 99.127 353.813 99.6063 337.768C100.086 321.724 100.648 306.571 110.172 305.973C117.799 305.49 115.381 315.7 115.204 324.358C115.027 333.015 115.308 345.082 119.278 342.197C123.248 339.311 119.903 296.938 132.042 293.391C140.086 291.051 137.94 300.327 138.294 310.412C138.648 320.496 139.575 324.053 141.524 323.266C143.472 322.479 145.129 308.827 145.848 301.282C146.567 293.737 150.141 283.17 157.143 283.601C164.145 284.031 161.759 295.994 159.862 300.212C157.966 304.43 157.935 309.257 159.185 309.814C160.435 310.37 167.687 296.906 173.981 301.765C180.274 306.624 172.095 318.796 164.697 321.64C157.299 324.484 147.4 328.576 148.422 331.294C149.443 334.012 158.018 330.727 164.77 328.146C171.522 325.564 174.793 326.047 175.481 327.894C177.773 333.938 170.907 342.407 165.978 344.295C161.05 346.184 132.011 353.173 133.532 357.192C135.053 361.211 145.671 357.433 151.12 355.335C156.57 353.236 169.302 348.356 171.845 355.093C174.387 361.83 158.633 372.04 147.994 375.377C137.356 378.714 119.726 382.807 120.904 385.871C122.081 388.935 136.762 388.096 143.389 385.556C150.016 383.017 160.55 375.115 163.686 383.405C166.822 391.695 157.351 397.256 144.348 402.293C138.919 404.392 125.415 409.398 116.382 407.603C106.098 405.504 100.638 406.229 100.044 408.653C98.8665 413.406 108.161 413.994 114.892 412.85C121.623 411.706 142.295 407.078 142.191 417.792C142.087 428.506 124.478 428.003 117.392 428.496C110.307 428.989 85.144 428.559 85.0085 434.099C84.8731 439.64 98.1892 436.314 102.43 435.726C106.671 435.138 115.819 436.775 114.162 440.417C112.506 444.058 71.4111 465.926 61.8773 462.883Z",
                fill: "#D9E8F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M231.664 373.38C239.466 371.645 240.655 363.675 240.915 358.898C238.567 359.637 229.217 363.161 231.664 373.38Z",
                fill: "#D9E8F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M203.26 440.966C205.321 423.518 214.351 396.008 232.225 371.449",
                stroke: "#D9E8F7",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M201.329 428.893C196.867 412.502 184.619 412.977 175.26 412.966C176.999 417.874 181.731 435.468 201.329 428.893Z",
                fill: "#D9E8F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M205.191 412.907C204.928 399.542 195.179 397.415 187.812 395.587C188.2 399.666 188.441 414.001 205.191 412.907Z",
                fill: "#D9E8F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M212.447 397.518C214.866 386.029 207.386 382.273 201.849 379.173C201.363 382.76 198.731 395.074 212.447 397.518Z",
                fill: "#D9E8F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M221.146 382.07C224.798 375.804 220.628 372.305 217.561 369.518C216.601 371.51 212.663 378.22 221.146 382.07Z",
                fill: "#D9E8F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M210.018 429.524C218.664 416.62 229.025 420.84 237.052 423.735C234.121 427.513 224.889 441.345 210.018 429.524Z",
                fill: "#D9E8F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214.846 412.493C220.27 401.044 229.21 403.032 236.087 404.302C234.167 407.716 228.377 420.039 214.846 412.493Z",
                fill: "#D9E8F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M222.57 392.937C228.598 386.122 234.433 389.333 238.984 391.605C236.978 393.548 230.529 400.876 222.57 392.937Z",
                fill: "#D9E8F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M229.328 380.67C231.898 375.954 235.347 377.209 238.018 378.046C237.098 379.426 234.397 384.492 229.328 380.67Z",
                fill: "#D9E8F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214.654 492.138C248.638 492.138 319.778 428.343 214.654 461.849C241.764 448.672 265.15 391.386 188.653 448.935C196.354 431.75 214.654 370.058 137.822 458.621C148.495 431.761 144.32 411.989 95.0904 469.621C112.03 444.076 83.4448 425.997 28.5023 492.128L214.654 492.138Z",
                fill: "#E7EEFF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M188.777 464.138C188.777 463.183 188.494 462.25 187.963 461.456C187.433 460.662 186.679 460.044 185.797 459.678C184.915 459.313 183.944 459.217 183.008 459.403C182.071 459.59 181.211 460.05 180.536 460.725C179.861 461.4 179.401 462.26 179.215 463.196C179.028 464.133 179.124 465.104 179.489 465.986C179.855 466.868 180.474 467.622 181.267 468.152C182.061 468.683 182.995 468.966 183.95 468.966C185.229 468.963 186.455 468.453 187.36 467.549C188.265 466.644 188.774 465.418 188.777 464.138Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M152.088 480.069C152.088 479.401 151.89 478.748 151.518 478.192C151.147 477.636 150.619 477.203 150.002 476.947C149.384 476.691 148.705 476.624 148.049 476.755C147.394 476.885 146.792 477.207 146.319 477.68C145.846 478.152 145.524 478.754 145.394 479.41C145.264 480.065 145.331 480.745 145.586 481.362C145.842 481.98 146.275 482.508 146.831 482.879C147.387 483.25 148.04 483.449 148.708 483.449C149.605 483.449 150.464 483.092 151.098 482.459C151.732 481.825 152.088 480.965 152.088 480.069Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.191 469.449C121.191 468.78 120.965 468.126 120.54 467.57C120.115 467.014 119.511 466.581 118.804 466.326C118.098 466.07 117.321 466.004 116.572 466.135C115.822 466.266 115.134 466.589 114.594 467.063C114.055 467.536 113.688 468.139 113.54 468.796C113.392 469.452 113.471 470.132 113.765 470.749C114.059 471.366 114.556 471.893 115.192 472.263C115.829 472.633 116.577 472.83 117.341 472.828C118.363 472.825 119.343 472.468 120.064 471.834C120.786 471.201 121.191 470.343 121.191 469.449Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M193.911 78.1259C181.184 83.7892 157.456 103.894 153.34 155.19C139.199 156.889 114.099 161.207 104.992 163.784C95.8848 166.361 114.565 179.146 116.531 179.146C135.226 179.146 170.098 176.144 170.098 176.144L193.911 78.1259Z",
                fill: "#D9E8F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M138.011 228.657L146.609 225.741C141.575 210.119 136.861 198.764 132.468 191.676C128.075 184.587 119.906 175.549 107.961 164.563C95.9979 153.595 87.4661 144.41 82.3658 137.01C77.2656 129.61 72.6508 119.902 68.5216 107.887C62.1298 89.2355 61.0738 74.2701 65.3539 62.9907C69.634 51.7112 76.7046 44.3583 86.5657 40.932C93.3727 38.3407 100.863 38.1758 107.777 40.4648C112.741 42.2063 115.796 44.7123 116.955 48.0961C117.719 50.352 117.587 54.3069 116.559 59.9608C114.24 72.7883 114.377 82.9823 116.969 90.5428C117.972 93.7766 119.635 96.7665 121.853 99.3231C124.071 101.88 126.795 103.947 129.852 105.395C132.93 106.884 136.277 107.734 139.692 107.892C143.107 108.05 146.518 107.514 149.72 106.315C153.429 105.125 156.846 103.168 159.75 100.57C162.654 97.9727 164.98 94.7926 166.577 91.2365C169.98 83.8837 170.131 75.6671 167.029 66.5869C161.373 50.0783 149.291 38.0485 130.785 30.4973C112.279 22.9462 90.2142 23.5409 64.5903 32.2813C37.4958 41.588 19.0745 55.1422 9.32652 72.944C-0.421463 90.7457 -2.15611 108.807 4.12257 127.128C8.53415 140.232 16.7097 151.742 27.6252 160.216C38.7873 168.975 57.1238 176.658 82.6345 183.266C99.7548 187.692 111.751 192.756 118.624 198.458C125.496 204.159 131.959 214.225 138.011 228.657Z",
                fill: "#FF8A00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.3265 95.4842C17.967 151.098 63.1905 165.341 102.517 179.217C127.335 187.966 135.042 216.028 140.062 228.02L137.983 228.728C131.931 214.239 125.468 204.149 118.596 198.458C111.723 192.766 99.736 187.702 82.6346 183.266C57.1239 176.715 38.811 169.056 27.6961 160.287C16.7805 151.813 8.60498 140.303 4.19341 127.199C-0.814499 113.17 -0.714325 97.822 4.47624 83.8602C9.70848 73.2273 24.9951 78.7632 23.3265 95.4842Z",
                fill: "url(#paint1_linear_13_352)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M220.143 79.3151C238.527 85.5731 242.147 93.8699 246.884 127C251.622 160.131 245.895 220.573 245.895 220.573H165.629C162.348 200.581 160.411 151.197 167.043 120.049C173.675 88.9003 188.877 83.0388 193.912 78.0551C208.491 78.1258 220.143 79.3151 220.143 79.3151Z",
                fill: "#E9EDF7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M201.986 110.393C210.329 86.5926 228.855 81.7646 235.557 94.4504C244.396 111.002 217.556 177.277 195.764 187.032C162.052 202.096 115.159 202.946 115.159 202.946C115.159 197.452 114.834 189.368 114.834 189.368C124.733 189.113 160.086 169.079 177.31 160.527C183.758 157.313 192.625 137.138 201.986 110.393Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M114.792 189.368C111.115 189.807 111.2 186.536 107.056 184.823C103.125 183.167 100.947 178.367 99.8726 179.245C98.7979 180.123 101.654 185.474 102.701 186.465C100.254 186.041 84.5436 180.349 83.6809 183.251C83.2284 184.752 85.0102 189.042 86.2405 191.647C87.9657 195.272 90.2424 199.194 96.1393 200.411C102.036 201.629 103.62 201.827 106.774 201.006C109.586 200.525 112.463 200.573 115.258 201.148C115.089 199.236 114.792 189.368 114.792 189.368Z",
                fill: "#FFD3C9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M196.429 68.4132C195.75 72.3492 194.039 80.6885 194.039 80.6885C195.736 82.9963 206.2 83.4352 218.305 79.2726C217.443 72.0519 218.022 55.3026 218.022 55.3026L196.429 68.4132Z",
                fill: "#FDC9C0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M186.205 26.6179C184.791 34.136 179.94 56.6194 184.38 64.718C188.029 71.3582 195.524 72.4768 207.6 68.3709C219.677 64.2649 220.172 42.3054 221.741 35.9624C224.386 25.9242 188.34 15.7019 186.205 26.6179Z",
                fill: "#FFD3C9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M225.56 22.4837C213.766 5.28137 213.511 13.1534 214.954 15.9709C202.835 5.45126 184.112 -1.81196 179.247 0.396738C174.383 2.60544 170.762 12.1057 179.247 21.3511C187.732 30.5965 200.685 27.1701 205.564 28.7134C207.394 29.2917 208.984 30.4552 210.09 32.0256C211.197 33.596 211.757 35.4863 211.687 37.4066C211.589 37.9263 211.518 38.4509 211.475 38.9782C211.915 38.6954 212.391 38.4717 212.889 38.3127C215.364 37.534 217.881 38.4684 218.545 40.4223C219.21 42.3761 217.655 44.599 215.166 45.3919C214.139 45.7252 213.038 45.7498 211.998 45.4627C213.144 50.5455 215.887 54.6231 218.418 54.2692C222.166 53.6604 237.353 39.6719 225.56 22.4837Z",
                fill: "#063668"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M159.336 487.344H172.205C175.938 478.056 189.174 412.022 194.576 353.958H149.324C150.852 400.511 155.094 453.463 159.336 487.344Z",
                fill: "#063668"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M165.615 220.573C158.544 244.132 149.31 295.499 149.353 353.958H194.604C207.671 295.739 236.462 237.11 238.824 220.573H165.615Z",
                fill: "#063668"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M172.247 492.059V487.344H159.336C159.267 490.251 158.791 493.135 157.922 495.91C161.26 497.198 166.138 493.885 172.247 492.059Z",
                fill: "#FFD3C9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M172.247 492.059C166.138 493.885 161.26 497.198 157.908 495.91C156.14 497.198 130.064 506.585 127.42 508.397C124.775 510.21 125.101 513.155 127.971 513.155C132.214 513.155 166.789 511.625 166.789 511.625C167.496 512.39 168.061 513.155 168.061 513.155H175.981C178.342 509.063 177.72 496.773 172.247 492.059Z",
                fill: "#063668"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M313.037 478.892L311.199 474.559L299.334 479.599C300.384 482.327 301.06 485.185 301.342 488.094C304.991 487.939 308.144 482.955 313.037 478.892Z",
                fill: "#FFD3C9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M313.037 478.891C308.144 482.955 304.948 487.939 301.37 488.052C300.239 489.935 279.918 508.794 278.193 511.512C276.468 514.231 277.924 516.793 280.569 515.661C284.429 514.018 315.681 499.025 315.681 499.025C316.629 499.463 317.449 499.945 317.449 499.945L324.788 496.844C325.297 492.144 319.91 481.086 313.037 478.891Z",
                fill: "#063668"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M253.573 351.821C250.208 287.867 246.291 228.091 245.88 220.573H172.657C175.203 238.483 189.966 317.77 213.073 378.651C219.818 393.517 292.815 473.143 299.334 479.67L311.156 474.63C298.684 445.195 277.429 386.48 253.573 351.821Z",
                fill: "#085295"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M150.852 258.503C146.418 260.011 142.326 262.381 138.81 265.477C135.293 268.573 132.423 272.334 130.362 276.544C128.302 280.753 127.093 285.329 126.804 290.008C126.515 294.687 127.152 299.378 128.678 303.81C130.135 308.3 132.491 312.445 135.6 315.994C138.71 319.543 142.508 322.421 146.765 324.452C150.973 326.537 155.551 327.767 160.236 328.071C164.922 328.375 169.621 327.746 174.062 326.222C178.503 324.698 182.599 322.307 186.113 319.19C189.626 316.072 192.488 312.288 194.534 308.057C198.664 299.514 199.256 289.682 196.181 280.703C193.107 271.725 186.613 264.326 178.116 260.117C173.922 257.998 169.34 256.762 164.651 256.484C159.961 256.207 155.265 256.894 150.852 258.503Z",
                fill: "#FF8A00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M130.304 276.555C133.816 269.488 139.543 263.766 146.608 260.263C153.674 256.76 161.69 255.67 169.433 257.158C167.507 257.45 165.613 257.924 163.777 258.574C160.174 259.798 156.849 261.723 153.992 264.239C151.136 266.754 148.805 269.811 147.133 273.232C145.461 276.654 144.481 280.373 144.251 284.175C144.02 287.977 144.543 291.787 145.789 295.385C146.972 299.015 148.877 302.367 151.387 305.24C153.897 308.114 156.962 310.449 160.397 312.106C166.457 315.1 173.372 315.875 179.943 314.297C186.514 312.72 192.327 308.889 196.372 303.47C195.839 305.05 195.211 306.596 194.491 308.1C192.446 312.331 189.584 316.115 186.07 319.232C182.557 322.35 178.461 324.74 174.02 326.264C169.578 327.789 164.879 328.417 160.194 328.114C155.509 327.81 150.93 326.58 146.722 324.495C138.225 320.287 131.732 312.887 128.657 303.909C125.582 294.93 126.174 285.099 130.304 276.555Z",
                fill: "url(#paint2_linear_13_352)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_13_352",
                        x1: "364.921",
                        y1: "512.659",
                        x2: "97.0586",
                        y2: "512.659",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F6F6FB"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DAE0F5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("linearGradient", {
                        id: "paint1_linear_13_352",
                        x1: "125.581",
                        y1: "237.251",
                        x2: "-2.67511",
                        y2: "86.8876",
                        gradientUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#FF9900"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("linearGradient", {
                        id: "paint2_linear_13_352",
                        x1: "182.061",
                        y1: "322.895",
                        x2: "141.431",
                        y2: "273.163",
                        gradientUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#FF9900"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/debtreliefanalysis/faq/accordionItem/style.module.scss
var style_module = __webpack_require__(59416);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/debtreliefanalysis/faq/accordionItem/index.tsx


const AccordionItem = ({ title , list , isOpen  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `flex flex-col ${(style_module_default())["border-bottom"]}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex p-2 cursor-pointer items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: `rounded-md w-8 h-8 flex items-center justify-center mr-4 text-[30px]`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `${(style_module_default()).plus} ${isOpen ? (style_module_default()).minus : ""}`
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base text-left text-[16px] md:text-[20px]",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(style_module_default()).answer} ${!isOpen ? "h-0 overflow-hidden" : "p-3 ml-3  min-h-3.5 overflow-auto"} text-sm text-gray-400 text-justify`,
                children: list.map((point, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: point
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var accordionItem = (AccordionItem);

;// CONCATENATED MODULE: ./src/components/debtreliefanalysis/faq/index.tsx




const questions = [
    {
        title: "What Is Debt Relief? ",
        list: [
            "Debt relief refers to various strategies and programs aimed at helping individuals and organizations reduce or eliminate their outstanding debts. This can include options such as debt consolidation, debt settlement, bankruptcy, and services like debt counseling and management plans.",
            "Debt relief programs can be helpful for those who are struggling to manage their debts due to financial challenges such as job loss or high-interest rates and can provide a pathway to financial stability and freedom.", 
        ]
    },
    {
        title: "How Can Debt Relief Help You?",
        list: [
            "Debt relief can help individuals struggling to manage their debts in several ways. Depending on the program or strategy chosen, debt relief can provide a path to reducing or eliminating outstanding debts, reducing interest rates and fees, and consolidating multiple debts into a single monthly payment. ",
            "Debt relief can also relieve the stress and anxiety associated with financial difficulties, allowing individuals to focus on rebuilding their financial stability and future. ", 
        ]
    },
    {
        title: "How Will This Impact Your Credit Score? ",
        list: [
            "The impact of debt relief on your credit score will depend on the type of debt relief program you choose and your financial situation. Debt settlement and bankruptcy, for example, may harm your credit score, as they involve negotiating with creditors or discharging debts entirely. Debt consolidation, on the other hand, may have a neutral or positive impact on your credit score if you can make timely payments on the new loan.",
            "It's essential to carefully consider the potential impact on your credit score before choosing a debt relief program and to work with a reputable company or professional to help you navigate the process and minimize any adverse effects. With responsible financial management and a commitment to rebuilding your credit, you can work to improve your credit score over time, even after pursuing debt relief.", 
        ]
    },
    {
        title: "What Is Included in the Free Evaluation?",
        list: [
            "One of our companies' expert Debt Relief advisors will contact you. They will discuss your debt, finances, and options. They will also discuss a general strategy for improving your credit score.", 
        ]
    }, 
];
function FAQ() {
    const { 0: activeTab , 1: setActiveTab  } = (0,react.useState)(0);
    const clickHandler = (idx)=>{
        if (idx === activeTab) {
            setActiveTab(-1);
            return;
        }
        setActiveTab(idx);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `flex  justify-between items-center flex-col lg:flex-row max-w-7xl mx-auto  px-4vw lg:px-4  lg:mb-20`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ` max-w-[750px]`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: `font-bold capitalize mb-12 text-3xl text-center md:text-left md:text-4xl `,
                        children: "frequently asked questions (FAQs)"
                    }),
                    questions?.map((item, idx)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: ()=>clickHandler(idx),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accordionItem, {
                                title: item.title,
                                list: item.list,
                                isOpen: idx === activeTab
                            })
                        }, idx);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `relative lg:w-[365px] lg:min-w-[365px] lg:h-[524px] w-[165px] h-[324px]`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqImage, {})
            })
        ]
    });
}


/***/ }),

/***/ 27969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HowThisWork; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/debtreliefanalysis/howThisWork/styles.module.scss
var styles_module = __webpack_require__(23269);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/debtreliefanalysis/icons/howThisWorkImage.tsx


function HowThisWorkImageIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "548",
        height: "439",
        viewBox: "0 0 548 439",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.92442 229.568C-4.51206 172.623 -1.39302 39.6078 119.518 5.02449C251.12 -32.6209 312.486 154.023 367.632 141.812C367.632 141.812 481.732 114.144 496.414 235.729C511.095 357.314 342.639 409.822 172.208 390.131C92.9076 380.967 11.435 313.72 1.92442 229.568Z",
                fill: "#EFF1F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M510.646 123.188H222.952C212.308 123.188 203.68 131.793 203.68 142.408V304.319C203.68 314.935 212.308 323.54 222.952 323.54H510.646C521.29 323.54 529.918 314.935 529.918 304.319V142.408C529.918 131.793 521.29 123.188 510.646 123.188Z",
                fill: "#A2BCD8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M505.295 175.691H233.48C228.863 175.691 225.119 179.425 225.119 184.03V190.939C225.119 195.544 228.863 199.277 233.48 199.277H505.295C509.913 199.277 513.656 195.544 513.656 190.939V184.03C513.656 179.425 509.913 175.691 505.295 175.691Z",
                fill: "#EFF1F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M529.918 254.969H203.68V282.494H529.918V254.969Z",
                fill: "#819FBE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M318.267 438.074C422.319 438.074 506.67 431.942 506.67 424.377C506.67 416.812 422.319 410.68 318.267 410.68C214.215 410.68 129.864 416.812 129.864 424.377C129.864 431.942 214.215 438.074 318.267 438.074Z",
                fill: "#E9E9E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M465.216 226.543H181.153C170.642 226.543 162.121 235.041 162.121 245.524V405.39C162.121 415.873 170.642 424.371 181.153 424.371H465.216C475.727 424.371 484.248 415.873 484.248 405.39V245.524C484.248 235.041 475.727 226.543 465.216 226.543Z",
                fill: "#071A6D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M459.506 226.543H175.443C164.932 226.543 156.411 235.041 156.411 245.524V405.39C156.411 415.873 164.932 424.371 175.443 424.371H459.506C470.017 424.371 478.538 415.873 478.538 405.39V245.524C478.538 235.041 470.017 226.543 459.506 226.543Z",
                fill: "#ADD6FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M228.218 299.956C238.572 289.629 238.572 272.887 228.218 262.56C217.864 252.234 201.077 252.234 190.723 262.56C180.368 272.887 180.368 289.629 190.722 299.956C201.077 310.282 217.864 310.282 228.218 299.956Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M430.185 281.258H378.15C368.596 281.258 360.852 288.982 360.852 298.51V317.451C360.852 326.979 368.596 334.703 378.15 334.703H430.185C439.739 334.703 447.484 326.979 447.484 317.451V298.51C447.484 288.982 439.739 281.258 430.185 281.258Z",
                fill: "#A2BCD8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M268.284 394.062H186.044C184.338 394.062 182.955 395.442 182.955 397.143V399.698C182.955 401.399 184.338 402.778 186.044 402.778H268.284C269.99 402.778 271.373 401.399 271.373 399.698V397.143C271.373 395.442 269.99 394.062 268.284 394.062Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M444.391 394.062H362.151C360.445 394.062 359.062 395.442 359.062 397.143V399.698C359.062 401.399 360.445 402.778 362.151 402.778H444.391C446.097 402.778 447.48 401.399 447.48 399.698V397.143C447.48 395.442 446.097 394.062 444.391 394.062Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M444.391 254.254H362.151C360.445 254.254 359.062 255.633 359.062 257.335V259.889C359.062 261.59 360.445 262.97 362.151 262.97H444.391C446.097 262.97 447.48 261.59 447.48 259.889V257.335C447.48 255.633 446.097 254.254 444.391 254.254Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M229.804 357.07H189.133C185.721 357.07 182.955 359.829 182.955 363.232V368.337C182.955 371.74 185.721 374.498 189.133 374.498H229.804C233.216 374.498 235.982 371.74 235.982 368.337V363.232C235.982 359.829 233.216 357.07 229.804 357.07Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M300.601 357.07H259.93C256.518 357.07 253.752 359.829 253.752 363.232V368.337C253.752 371.74 256.518 374.498 259.93 374.498H300.601C304.013 374.498 306.779 371.74 306.779 368.337V363.232C306.779 359.829 304.013 357.07 300.601 357.07Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M371.399 357.07H330.728C327.316 357.07 324.55 359.829 324.55 363.232V368.337C324.55 371.74 327.316 374.498 330.728 374.498H371.399C374.811 374.498 377.577 371.74 377.577 368.337V363.232C377.577 359.829 374.811 357.07 371.399 357.07Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M442.197 357.07H401.526C398.114 357.07 395.348 359.829 395.348 363.232V368.337C395.348 371.74 398.114 374.498 401.526 374.498H442.197C445.609 374.498 448.375 371.74 448.375 368.337V363.232C448.375 359.829 445.609 357.07 442.197 357.07Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M116.445 439.002C151.608 439.002 180.113 436.883 180.113 434.27C180.113 431.657 151.608 429.539 116.445 429.539C81.2817 429.539 52.7764 431.657 52.7764 434.27C52.7764 436.883 81.2817 439.002 116.445 439.002Z",
                fill: "#E9E9E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M122.129 426.171C122.129 426.171 109.892 373.67 118.493 351.825L107.088 280.186L140.963 279.812L129.85 425.977L122.129 426.171Z",
                fill: "#E3633D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M129.868 423.991L136.402 429.092C137.678 430.343 144.789 432.931 144.789 432.931C145.452 434.451 144.04 435.171 142.831 435.343L121.627 434.163C121.627 434.163 116.759 432.979 121.432 423.707C125.236 425.544 128.759 426.885 129.868 423.991Z",
                fill: "#2E203D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M144.209 290.891L141.318 352.559L135.979 414.578L111.326 416.546C111.326 416.546 112.775 405.716 112.232 402.356C111.689 398.995 108.222 367.048 114.55 351.715L109.136 291.761L144.209 290.891Z",
                fill: "#0E2CA9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M114.377 351.741L108.963 291.783L120.716 291.488L124.682 335.396C125.368 343.657 124.999 351.972 123.581 360.14C120.866 376.447 123.304 398.681 123.753 401.448C124.296 404.809 122.847 415.639 122.847 415.639L111.153 416.572C111.153 416.572 112.599 405.743 112.056 402.382C111.513 399.021 108.046 367.074 114.377 351.741Z",
                fill: "#071A6D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M103.139 110.653C103.231 109.552 104.199 108.735 105.299 108.827C111.682 109.365 118.216 110.927 124.784 113.661C125.804 114.085 126.286 115.256 125.862 116.275C125.438 117.295 124.267 117.778 123.247 117.354C117.052 114.775 110.923 113.315 104.964 112.813C103.863 112.721 103.046 111.753 103.139 110.653ZM69.6231 119.077C70.2106 120.013 69.9287 121.247 68.9933 121.835C58.3483 128.521 49.6091 138.364 43.9712 149.731C43.4805 150.721 42.2804 151.125 41.2909 150.634C40.3013 150.144 39.897 148.944 40.3878 147.954C46.3399 135.953 55.5713 125.542 66.8657 118.448C67.8011 117.86 69.0356 118.142 69.6231 119.077ZM35.2862 184.757C36.381 184.61 37.3875 185.379 37.5342 186.474C38.3487 192.547 40.1367 198.595 43.0288 204.441C43.5186 205.431 43.113 206.631 42.123 207.121C41.1329 207.61 39.9333 207.205 39.4435 206.215C36.3537 199.969 34.4407 193.501 33.5697 187.005C33.4229 185.911 34.1914 184.904 35.2862 184.757Z",
                fill: "#0E5AA9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M198.546 29.9023C195.812 29.9023 193.608 32.1112 193.608 34.819C193.608 37.5269 195.812 39.7358 198.546 39.7358C201.281 39.7358 203.484 37.5269 203.484 34.819C203.484 32.1112 201.281 29.9023 198.546 29.9023ZM187.608 34.819C187.608 28.7823 192.513 23.9023 198.546 23.9023C204.58 23.9023 209.484 28.7823 209.484 34.819C209.484 40.8558 204.58 45.7358 198.546 45.7358C192.513 45.7358 187.608 40.8558 187.608 34.819Z",
                fill: "#0E5AA9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M536.939 366.078C534.204 366.078 532.001 368.287 532.001 370.995C532.001 373.703 534.204 375.912 536.939 375.912C539.674 375.912 541.877 373.703 541.877 370.995C541.877 368.287 539.674 366.078 536.939 366.078ZM526.001 370.995C526.001 364.958 530.906 360.078 536.939 360.078C542.972 360.078 547.877 364.958 547.877 370.995C547.877 377.032 542.972 381.912 536.939 381.912C530.906 381.912 526.001 377.032 526.001 370.995Z",
                fill: "#0E5AA9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M192.401 181.521C215.436 181.521 234.109 162.897 234.109 139.924C234.109 116.951 215.436 98.3281 192.401 98.3281C169.367 98.3281 150.693 116.951 150.693 139.924C150.693 162.897 169.367 181.521 192.401 181.521Z",
                fill: "#FF8A00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214.126 104.414C220.232 108.127 225.277 113.344 228.776 119.563C232.276 125.782 234.113 132.795 234.109 139.927C234.108 150.959 229.714 161.538 221.892 169.338C214.07 177.138 203.462 181.52 192.401 181.52C181.34 181.52 170.732 177.138 162.911 169.338C155.089 161.538 150.694 150.959 150.693 139.927C150.677 130.921 153.604 122.154 159.032 114.956",
                stroke: "#0E5AA9",
                strokeWidth: "4.85",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M204.089 102.515C200.307 101.343 196.369 100.75 192.409 100.756L192.404 100.756C190.634 100.756 188.865 100.873 187.111 101.108C185.783 101.286 184.563 100.354 184.385 99.0267C184.207 97.6993 185.139 96.479 186.467 96.3012C188.435 96.0375 190.418 95.9056 192.404 95.9063C196.852 95.9 201.275 96.5661 205.524 97.882C206.803 98.2783 207.519 99.6366 207.123 100.916C206.726 102.195 205.368 102.911 204.089 102.515Z",
                fill: "#0E5AA9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M102.553 262.172L102.036 350.611L98.8008 425.648L91.7765 425.917C87.4818 399.127 73.0549 379.612 80.259 347.187L77.1699 286.807L88.7548 265.092L102.553 262.172Z",
                fill: "#C95836"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104.673 261.715L104.351 352.552L103.767 415.475C103.797 416.4 103.46 417.3 102.829 417.979C102.198 418.657 101.324 419.061 100.397 419.101L87.318 419.474C86.6235 419.492 85.9479 419.247 85.428 418.787C84.908 418.327 84.5825 417.688 84.5172 416.998C83.9294 411.3 82.6039 404.074 81.8962 400.784C78.3466 384.696 74.827 376.055 77.2009 347.955L73.5801 285.775L88.7858 265.068L104.673 261.715Z",
                fill: "#0E2CA9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M85.3775 244.164L126.835 245.908C138.296 267.149 136.252 293.658 136.252 293.658L105.724 295.063C91.6044 294.767 74.9047 305.814 73.1486 282.366C71.1379 255.524 85.3775 244.164 85.3775 244.164Z",
                fill: "#0E2CA9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M98.8497 424.905C98.8497 424.905 102.298 430.988 103.523 434.786C103.624 435.098 103.65 435.43 103.599 435.755C103.547 436.079 103.42 436.387 103.227 436.653C103.032 436.915 102.776 437.124 102.481 437.264C102.186 437.403 101.861 437.468 101.534 437.452L97.4493 437.265C96.8119 437.235 96.2019 436.997 95.712 436.59L94.6748 435.731C92.9449 434.3 92.1586 432.717 92.1361 430.503C92.0966 428.879 91.9716 427.259 91.7617 425.648C94.4052 423.001 98.8497 424.905 98.8497 424.905Z",
                fill: "#2E203D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M173.511 220.549L170.845 223.806C169.921 224.937 168.62 225.699 167.179 225.953L161.346 226.987C160.876 227.07 160.392 227.038 159.937 226.894C159.482 226.75 159.068 226.498 158.732 226.159C158.396 225.821 158.147 225.406 158.007 224.95C157.867 224.495 157.839 224.012 157.927 223.544L164.615 218.888C165.985 217.394 171.062 216.225 173.309 215.938C173.905 216.547 174.255 217.354 174.292 218.205C174.329 219.056 174.051 219.89 173.511 220.549V220.549Z",
                fill: "#C95836"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M119.852 191.352C119.852 191.352 105.545 190.355 105.537 178.947C105.53 167.538 113.715 166.25 113.715 166.25L122.585 183.682L119.852 191.352Z",
                fill: "#2E203D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M149.11 239.457L136.551 201.539C133.41 192.913 124.764 189.418 118.38 194.194C115.864 196.061 115.149 200.128 116.774 203.291L136.993 242.699L149.11 239.457Z",
                fill: "#C95836"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M126.686 192.255L114.621 188.065L104.268 186.855L99.191 187.057L79.8928 193.779C76.7569 195.325 74.3044 197.972 73.0064 201.211C71.7085 204.451 71.6566 208.055 72.861 211.33L77.5863 233.362C72.569 249.98 69.8168 254.118 70.6892 271.217C95.8997 275.586 138.836 271.217 140.839 268.932C139.368 234.696 135.376 209.508 126.686 192.255Z",
                fill: "#A5BFDB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M114.355 188.087C114.355 188.087 120.425 203.069 110.113 203.726C99.8011 204.383 94.1621 188.815 94.1621 188.815L101.692 185.477L114.355 188.087Z",
                fill: "#C95836"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M68.6478 255.781L86.115 214.252C90.2337 205.682 86.8264 197.508 79.0008 197.074C75.9155 196.903 72.4895 199.535 71.31 202.978L56.9355 247.211L68.6478 255.781Z",
                fill: "#C95836"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M56.9062 247.215C59.1528 254.24 64.9191 258.915 73.1079 257.593L110.622 242.969L104.594 236.621L74.8116 242.805L56.9062 247.215Z",
                fill: "#C95836"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M90.7402 207.1L81.3045 232.691L60.1865 225.084C64.2379 220.692 68.4241 199.691 79.8967 193.768C92.4888 187.259 90.7402 207.1 90.7402 207.1Z",
                fill: "#A5BFDB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M126.685 192.258C126.685 192.258 134.829 192.818 139.127 206.851C143.426 220.885 147.215 223.738 147.215 223.738L131.781 229.974L119.945 200.884L126.685 192.258Z",
                fill: "#A5BFDB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M135.671 227.604C135.671 227.604 132.639 218.824 130.111 213.865C127.584 208.906 128.482 205 128.482 205",
                stroke: "#CEE2E8",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M79.5146 230.972L87.5237 210.303L87.1381 206.105",
                stroke: "#CEE2E8",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M105.145 270.781L157.823 263.197L166.087 208.176L120.009 213.867C116.789 214.266 112.521 217.358 111.746 221.53L105.145 270.781Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M101.599 240.676L105.261 234.357C105.993 233.095 107.156 232.136 108.537 231.657L114.127 229.712C114.578 229.555 115.061 229.509 115.533 229.579C116.006 229.648 116.455 229.831 116.841 230.112C117.227 230.392 117.539 230.762 117.751 231.189C117.962 231.616 118.066 232.088 118.055 232.565V232.565L113.004 240.242C111.78 242.015 109.971 243.302 107.893 243.88L104.276 244.948L101.599 240.676Z",
                fill: "#C95836"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M106.574 164.598C106.574 164.598 77.0766 186.869 88.0175 195.219C94.8696 200.447 110.884 175.457 110.884 175.457L106.574 164.598Z",
                fill: "#2E203D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M112.797 179.024C112.797 179.024 111.88 185.876 111.124 191.556C111.025 192.298 110.73 193 110.269 193.59C109.809 194.181 109.199 194.639 108.503 194.917C107.812 195.194 107.059 195.281 106.324 195.169C105.588 195.057 104.896 194.749 104.32 194.278L103.197 193.367C102.404 192.718 101.811 191.859 101.485 190.889C101.159 189.918 101.114 188.876 101.355 187.882L104.893 173.18L112.756 179.028L112.797 179.024Z",
                fill: "#C95836"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M112.322 183.879L111.461 187.949C108.544 186.967 107.009 184.245 105.762 181.156L112.322 183.879Z",
                fill: "#873B24"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M106.185 168.225C106.484 167.303 107.136 166.536 107.999 166.092C108.863 165.648 109.867 165.562 110.794 165.854L117.455 167.997C119.369 168.613 120.102 170.611 119.773 172.601C119.398 174.958 117.526 179.506 115.755 182.643C114.763 184.413 112.707 185.675 110.794 185.059C108.753 184.402 103.275 180.473 103.89 176.608C104.358 173.669 105.256 171.059 106.185 168.225Z",
                fill: "#C95836"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M115.782 168.593C115.782 168.593 109.791 173.272 105.762 172.954C101.733 172.637 102.115 174.534 102.115 174.534C102.115 174.534 103.377 164.287 108.945 163.6C112.798 163.13 114.587 162.652 115.782 168.593Z",
                fill: "#2E203D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M101.549 175.191C101.598 176.852 102.748 178.152 104.118 178.1C105.488 178.047 106.559 176.658 106.511 174.996C106.462 173.335 105.312 172.035 103.942 172.087C102.572 172.14 101.501 173.533 101.549 175.191Z",
                fill: "#C95836"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M122.533 171.29C123.776 174.894 123.151 182.807 124.341 187.949C124.626 189.163 127.258 191.355 126.359 193.061C125.988 193.617 125.662 194.202 125.382 194.809C125.112 195.371 124.676 195.837 124.131 196.143C123.587 196.45 122.961 196.581 122.339 196.52C121.717 196.46 121.129 196.209 120.654 195.804C120.18 195.398 119.842 194.856 119.687 194.252C119.371 193.035 119.137 191.797 118.987 190.548C118.099 182.381 119.103 174.05 115.4 170.891C114.586 170.375 113.918 169.66 113.459 168.814C113.001 167.969 112.766 167.02 112.779 166.059C112.831 162.731 119.533 165.345 122.533 171.29Z",
                fill: "#2E203D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M166.117 206.111C166.117 206.111 174.474 205.737 174.83 217.157L122.566 225.764C122.566 225.764 131.849 220.163 120.941 213.863L166.117 206.111Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M171.901 217.958L122.585 226.962C122.585 226.962 123.072 216.233 115.377 217.559",
                stroke: "#9197EB",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M171.418 308.085C180.655 300.553 178.708 284.593 170.643 281.116C159.036 276.108 157.823 263.191 157.823 263.191L105.144 270.776C103.391 286.605 113.19 288.723 119.979 293.294C123.817 295.874 122.888 301.565 121.357 306.024C120.396 308.737 119.102 311.321 117.504 313.716C115.542 316.704 112.101 323.575 115.905 330.681C120.978 340.151 139.236 350.1 139.236 350.1L196.453 339.334C196.453 339.334 152.251 337.967 171.418 308.085Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M175.49 117.749L169.659 123.258L206.544 162.09L212.375 156.582L175.49 117.749Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M207.721 118.619L168.787 155.402L174.311 161.217L213.245 124.434L207.721 118.619Z",
                fill: "white"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/debtreliefanalysis/howThisWork/index.tsx




const steps = [
    {
        id: 1,
        text: "After you fill out the form above, you will be connected with one of our best debt repair companies."
    },
    {
        id: 2,
        text: "Once you are connected with the company, a representative will call you to ask you some questions about your debt situation, finances, and history."
    },
    {
        id: 3,
        text: "After that, the company will recommend debt relief options.  In addition to this, the company will also recommend strategies for preventing debt in the future. "
    },
    {
        id: 4,
        text: "Congratulations! You are on your way to being debt free and financially secure!  "
    }, 
];
function HowThisWork() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `flex ${(styles_module_default()).howThisWork} flex-col md:flex-row max-w-7xl mx-auto  px-4vw lg:px-4`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(styles_module_default()).howThisWorkListWrapper}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: `font-bold capitalize mb-12 text-2xl text-center md:text-left md:text-4xl `,
                        children: [
                            "How",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[#ff8a00]",
                                children: "DebtReliefAnalysis.com"
                            }),
                            " ",
                            "Works"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: steps.map((step)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: `flex justify-start items-center mb-12`,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: `flex justify-center items-center font-bold ${(styles_module_default()).stepNum}`,
                                        children: step.id
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: `${(styles_module_default()).stepText} text-base md:text-xl`,
                                        children: step.text
                                    })
                                ]
                            }, step.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ` ${(styles_module_default()).howThisWorkImage}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowThisWorkImageIcon, {})
            })
        ]
    });
}


/***/ }),

/***/ 33145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96119);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4762);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47496);
/* harmony import */ var _styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);
/* harmony import */ var _components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45464);









function MainBanner() {
    const { visitDetails , domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const isFormDisplayed = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .finalShowForm */ .r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isFormDisplayed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["main-banner"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                classes: {
                    formClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().form),
                    stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-title"]),
                    stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-description"]),
                    formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-button"]),
                    formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-field"]),
                    formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["steps-inner"]),
                    stepClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().step),
                    fieldsClassName: {
                        radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["radio-field"]),
                        checkbox: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["checkbox-field"]),
                        all: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().field),
                        input: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["input-field"])
                    },
                    fieldsWrapperClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["fields-wrapper"]),
                    tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tcpa),
                    labelAsTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["label-as-step-title"]),
                    fieldNoteClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["field-note"]),
                    fieldErrorMessageClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["field-error-message"]),
                    sellingPointClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["selling-point"])
                },
                colors: {
                    primaryColor: (_styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().mainColor),
                    progressBar: "#D9D9D9"
                },
                showProgress: true,
                goToThankYouPage: false,
                sellingPoint: visitDetails?.region ? `${visitDetails?.region}'s Best Debt Relief Companies` : "",
                sellingPointsSteps: "FIRST_STEP",
                dynamicThankYouFields: [
                    "firstName"
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    });
}


/***/ }),

/***/ 59416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"answer":"style_answer__1C04H","border-bottom":"style_border-bottom__KXwZf","border":"style_border__InTP3","plus":"style_plus__C_56L","minus":"style_minus__U20G1"};

/***/ }),

/***/ 23269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","howThisWork":"styles_howThisWork__E7DLI","howThisWorkImage":"styles_howThisWorkImage__NpcU7","howThisWorkListWrapper":"styles_howThisWorkListWrapper__pu1Sk","stepNum":"styles_stepNum__4JpRN","stepText":"styles_stepText__9Kr7X"};

/***/ }),

/***/ 4762:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","selling-point":"styles_selling-point__RrR1g","main-banner":"styles_main-banner__DIHXj","form":"styles_form__0EvoA","step":"styles_step__VGh3Q","form-field":"styles_form-field__60r2f","steps-inner":"styles_steps-inner__EK7GG","step-title":"styles_step-title__sbR3R","label-as-step-title":"styles_label-as-step-title__iG0SD","step-description":"styles_step-description__C4KRt","fields-wrapper":"styles_fields-wrapper__mwDmN","form-button":"styles_form-button__YYRj3","radio-field":"styles_radio-field__OnV4V","checkbox-field":"styles_checkbox-field__UH9ux","field-note":"styles_field-note__zvnFO","input-field":"styles_input-field__YedjZ","field-error-message":"styles_field-error-message__UOM0Q","field":"styles_field__kEKiD","tcpa":"styles_tcpa__eHFYm","image":"styles_image__DD3wh","offerContainer":"styles_offerContainer__thO2v"};

/***/ }),

/***/ 47496:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#244880","paragraphColor":"#232323"};

/***/ })

}]);